import { env } from './env';

const devPrefix = env.DEV ? 'fashion:' : '';

function withPrefix(key: string) {
  return `${devPrefix}${key}`;
}

export const storageKeys = {
  accessToken: withPrefix('accessToken'),
  demoTags: withPrefix('demo_tags'),
  favoriteAdminCards: withPrefix('favorite_admin_cards'),
  addSliceProductToFirstPosition: withPrefix(
    'add_slice_product_to_first_position',
  ),
};
